module.exports = __webpack_public_path__ + "img/eg.18f5e988.svg";